import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import './Menu.css';
import { addToOrder, updateOrderQuantity } from '../../../slices/order/orderSlice';

export const MenuItemDetail = ({ item, onClose }) => {
    const dispatch = useDispatch();
    const currentOrder = useSelector(state => state.Order.currentOrder);
    const existingOrderItem = currentOrder.find(orderItem => orderItem.id === item.id);
    
    const [localQuantity, setLocalQuantity] = useState(existingOrderItem ? existingOrderItem.quantity : 1);

    const calculateDiscountedPrice = () => {
        const price = item.price;
        const discount = item.discountDetail?.discountPercentage || 0;
        return price - (price * discount / 100);
    };

    const calculateTotalPrice = () => {
        return calculateDiscountedPrice() * localQuantity;
    };

    const handleIncrement = () => {
        setLocalQuantity(prev => prev + 1);
    };

    const handleDecrement = () => {
        setLocalQuantity(prev => (prev > 1 ? prev - 1 : 1));
    };

    const handleAddToOrder = () => {
        if (existingOrderItem) {
            dispatch(updateOrderQuantity({
                itemId: item.id,
                quantity: localQuantity
            }));
        } else {
            dispatch(addToOrder({
                item: {
                    ...item,
                    price: calculateDiscountedPrice()
                },
                quantity: localQuantity
            }));
        }
        
        // Close modal if onClose prop is provided
        if (onClose) {
            onClose();
        }
    };

    return (
        <div>
            <div className="text-center menu-item-detail-pos mb-3">
                <img
                    src={item?.cloudR2ImagePath?.getCDNUrl() || 'https://via.placeholder.com/150'}
                    alt={item.title}
                    className='img-fluid'
                />
            </div>
            <div className="mb-3">
                <h4 className="fw-bold">{item.title}</h4>
                <p className="text-muted">{item.description || 'No description available.'}</p>
            </div>
            <div className="mb-3">
                {item.discountDetail && (
                    <p className="mb-1 text-muted">
                        <span className="fw-bold">Original Price:</span> Rs. {item.price}
                    </p>
                )}
                {item.discountDetail && (
                    <p className="mb-1 text-danger">
                        <span className="fw-bold">Discount:</span> {item.discountDetail.discountPercentage}% OFF
                    </p>
                )}

                <p className="mb-1">
                    <span className="fw-bold">Price:</span> Rs. {calculateDiscountedPrice()}
                </p>
            </div>
            <div className="d-flex align-items-center gap-3 mb-3">
                <Button color="light" size="sm" onClick={handleDecrement}>
                    -
                </Button>
                <span className="fw-bold">{localQuantity}</span>
                <Button color="light" size="sm" onClick={handleIncrement}>
                    +
                </Button>
            </div>
            <div className="mb-3">
                <p className="fw-bold">
                    Total Price: Rs. {calculateTotalPrice()}
                </p>
            </div>
            <div className="text-center">
                <Button 
                    color="primary" 
                    size="lg" 
                    className="w-100"
                    onClick={handleAddToOrder}
                >
                    {existingOrderItem ? 'Update Cart' : 'Add to Order'}
                </Button>
            </div>
        </div>
    );
}; 